<template>
  <v-row align="center" justify="center">
    <v-overlay
          :absolute="true"
          color="black"
          opacity=0.6
          value="true"
          z-index=-0
        >
    
      <a-login-form/>
      <a-forgot-password/>
    </v-overlay>
  </v-row>
</template>

<script>
// @ is an alias to /src
import ALoginForm from '@/components/ALoginForm.vue'
import AForgotPassword from '@/components/AForgotPassword.vue'

export default {
  name: 'Login',
  components: {
    ALoginForm,
    AForgotPassword
  },
  mounted() {
    // This hides the address bar:
    const h = window.screen.height
    const w = window.screen.width    
    const target = document.querySelector("#askme")
    this.$functions.Resources.getUnsplashImage(w, h)
      .then(imageUrl => {
        console.log("Setting background image to ", imageUrl)
        if (imageUrl && target) {
          target.style.backgroundSize = "cover"
          target.style.backgroundImage = `url('${imageUrl}')`
        }
      })
  },
  destroyed() {
    document.querySelector("#askme").style.backgroundImage = "none"
  }
}
</script>

<style lang="scss">

</style>
